
import React from "react";
import {getBrand, authenticate, findCenter} from "../lib/functions";
import FadeIn from "./Fadein.js";
import Footer from "./Footer";
import SsoButtons from "./SsoButtons";



export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        brand : null,
        loginCenterId : '',
        step : 0,
        loginError : '',
        schoolname : null,
        loginUsername : '',
        loginPassword : '',
        maintenanceMessage: true
    }
  }

    componentDidMount = () =>  {
        this.setState({brand : getBrand(), step : 1});
    }

    updateValue = (e) => {
        this.setState({[e.target.id] : e.target.value});
        this.setState({loginError : ''});
    }

    loginFindCenter = () => {
        if(this.state.loginCenterId) {
            this.setState({loginError : ''});
            findCenter(this.state.loginCenterId, (data) => {

                if(data.error === 1) {
                    this.setState({loginError : data.txt});
                }
                if(data.error === 0) {
                    this.setState({
                        schoolname : data.schoolname,
                        step : 2
                    });
                }
            });
        }
        else {
            this.setState({loginError : 'Please enter a valid centre ID.'});
        }
    }

    login = () => {
        if(this.state.loginUsername && this.state.loginPassword) {
            this.setState({loginError : ''});
            authenticate(this.state.loginUsername, this.state.loginPassword, (data) => {

                if(data.error === 0) {
                    this.props.loggedIn(data);
                }
                else {
                    this.setState({loginError : data.txt});
                }
            })
        }
        else {

            this.setState({loginError : 'User name and password are required.'});
        }
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            if(this.state.step == 1) {
                this.loginFindCenter();
            }
            if(this.state.step == 2) {
                this.login();
            } else {
        }
      }
    }

  render() {

            return (
            <div className="login-background" onKeyPress={this.handleKeyPress}>

            {this.state.maintenanceMessage ? 
                <div className="maintenance-container">
                    <div className="maintenance-message">
                        The Exampro Onscreen Student Portal will be undergoing maintenance between <strong>6pm</strong> and <strong>6.30pm</strong> on <strong>Monday the 9th February</strong>. You can still do your work during this period. 
                        <br/>
                        <br/>
                        You may see some minor visual glitches whilst updates are being made. If so, these will be temporary and no work will be lost as a result while using Exampro.
                    </div>
                </div>    
                :
                ""
            }          
              
               { this.state.step == 1 ?
                <FadeIn>
                    <div tabIndex="-1" role="dialog">

                        <div className="modal-dialog initial-login" role="document">
                            <div className="modal-content login-content">
                            <div className="modal-header display-block no-border no-padding">
                                <div className="page-section-header text-center">Please log in</div>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="schoolSearch">Centre&nbsp;ID</label>
                                    <div>
                                        <input type="text" autoFocus  autoComplete="new-password" className="form-control" name="" id="loginCenterId"  value={this.state.loginCenterId} onChange={this.updateValue}/>
                                    </div>
                                </div>
                                 <div className="text-center display-block no-border">

                                   <div className="login-error-message">{this.state.loginError}</div>

                                <button type="button" className="btn btn-primary btn-100" onClick={this.loginFindCenter}>Continue</button>

                                </div>

                               <div className="login-block mt-5">

                                <p>Or, if you have linked your account:
                                  <i className="fa fa-info-circle text-ep-primary help-button" data-url="https://stsupport.exampro.co.uk/kb/?lnd=7E6" onClick={this.props.gethelp}></i>
                                </p>
                                <div className="d-flex justify-content-between">
                                    <SsoButtons type='login'/>
                                </div>
                            </div>

                            </div>
                          </div>
                        </div>
                    </div>

                </FadeIn>
                : null }

            { this.state.step == 2 ?
                <FadeIn>
                    <div tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-header no-border">
                              <div className="page-section-header text-center">{this.state.schoolname}</div>
                        </div>
                        <div className="modal-body">
                            <div className="form-group row">
                                <label className="col-sm-3" htmlFor="schoolSearch">User name</label>
                                <div className="col-sm-9">
                                    <input type="text" autoComplete="new-password" className="form-control" name="" id="loginUsername" autoFocus value={this.state.loginUsername} onChange={this.updateValue}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3" htmlFor="schoolSearch">Password</label>
                                <div className="col-sm-9">
                                    <input type="password" autoComplete="new-password" className="form-control" name="" id="loginPassword" value={this.state.loginPassword} onChange={this.updateValue}/>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer no-border d-flex justify-content-between">
                            <div className="login-error-message">{this.state.loginError}</div>
                            <button type="button" className="btn btn-primary" id="loginAuthenticate" onClick={this.login}>Login</button>
                        </div>
                        </div>
                    </div>
                    <p className="quick-guide-text">For guidance please see the <a href="https://stsupport.exampro.co.uk/kb/ " target="_blank" rel="noreferrer">Student Portal Quick Guide</a></p>
                    </div>
                </FadeIn>
            : null
            }





            <Footer />
            </div>

         )
   }
}
